export const getBubbleThumbnail = (name: string): string => {
    const [firstNameThumbnail, secondNameThumbnail] = name.split(' ').map(name => name[0]);

    return [firstNameThumbnail, secondNameThumbnail].join('');
};
